import { render, staticRenderFns } from "./freightInstall.vue?vue&type=template&id=4ac6c97a&scoped=true&"
import script from "./freightInstall.vue?vue&type=script&lang=ts&"
export * from "./freightInstall.vue?vue&type=script&lang=ts&"
import style0 from "./freightInstall.vue?vue&type=style&index=0&id=4ac6c97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac6c97a",
  null
  
)

export default component.exports